<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <v-btn class="mr-2" exact :to="{ name: 'Welcome' }" color="primary" fab small>
        <v-icon>mdi-home</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn class="mr-2" exact :to="{name: 'Welcome Support'}" color="primary" fab small>
        <v-icon>mdi-face-agent</v-icon>
      </v-btn>
      
      <span style="margin-right:10px" v-if="$vuetify.breakpoint.lgAndUp">{{ $t('Support') }}</span>
      <v-divider v-if="$vuetify.breakpoint.lg" vertical style="margin-right:10px"></v-divider>

      <selectLang></selectLang>
      <v-btn :to="{ name: 'Login' }" data-cy="button-login" outlined class="text-none">{{ $t('Login') }}</v-btn>
    </v-app-bar>

    <v-main
      class="main-content"
      :class="$vuetify.breakpoint.lgAndUp ? 'display-background-image' : ''"
    >
      <router-view></router-view>
    </v-main>
    <app-footer></app-footer>
    <cookie-consent></cookie-consent>
    <snackbar></snackbar>
  </v-app>
</template>

<script>
import Snackbar from "@/components/Snackbar";
import AppFooter from "@/components/AppFooter";
import SelectLang from "../components/SelectLang";
import CookieConsent from "../components/CookieConsent"

export default {
  name: "Welcome",
  components: { Snackbar, AppFooter, SelectLang, CookieConsent },
  metaInfo() {
    return {
      title: this.$t("TBC Admin Portal"),
    };
  },
};
</script>

<style scoped>
.main-content {
  min-height: 85vh;
}

.display-background-image {
  background-image: url("~@/assets/SLOGAN_SIMPLIFIEZ@2x-8_rotate.png");
  background-attachment: fixed;
  background-position: left 0% top 10vh;
  background-repeat: no-repeat;
  background-size: auto 70%;
}
</style>
